import { HeroCard } from 'components/HeroCard';
import { PlaceholderHeroCard } from 'components/PlaceholderHeroCard';
import { useListEngagementData } from 'components/SnowplowEngagementAnalytics/hooks';
import { useCards } from 'hooks/useCards';
import * as React from 'react';
import { getCardKey } from 'utils/card';
import { ListLayoutProps } from '../ListLayoutProps';
import { ListNotifications } from '../ListNotifications';

const PAGE_SIZE = 1;

export const HeroList: React.FunctionComponent<ListLayoutProps> = ({
  index,
  list,
  listKey,
}) => {
  const { cards, loading, notifications, meta } = useCards({
    source: list.source,
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  });
  const groupEngagementData = useListEngagementData({
    cardPageMeta: meta,
    isPaginated: false,
    list,
    listIndex: index,
    tabTitle: undefined,
  });

  return (
    <>
      <ListNotifications listStyle={list.style} notifications={notifications} />

      {cards.map((card, index) => {
        const key = getCardKey(card, index, listKey);

        return (
          <HeroCard
            card={card}
            cardKey={key}
            groupEngagementData={groupEngagementData}
            key={key}
            imageAspectRatio={list.style?.image}
          />
        );
      })}

      {loading && <PlaceholderHeroCard imageAspectRatio={list.style?.image} />}
    </>
  );
};
